"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const useFetch_1 = __importDefault(require("../../../hooks/useFetch"));
const common_styled_components_1 = require("../../common-styled-components");
const apiUtils_1 = require("../../../util/apiUtils");
const theme_1 = require("../../../theme");
const PoolTable_1 = require("../common/tables/PoolTable");
const useMetadata_1 = require("../../../hooks/useMetadata");
const FleetTable_1 = require("../common/tables/FleetTable");
const ShipTable_1 = require("../common/tables/ShipTable");
const NumberKPI_1 = __importDefault(require("../common/NumberKPI"));
const react_router_dom_1 = require("react-router-dom");
const useFetchAll_1 = __importDefault(require("../../../hooks/useFetchAll"));
const react_1 = require("react");
const CompanyYearlyPlanTable_1 = require("../common/tables/CompanyYearlyPlanTable");
const YearContext_1 = require("../../../contexts/YearContext");
const BookingTable_1 = require("../common/tables/BookingTable");
exports.default = () => {
    const { companyId } = (0, react_router_dom_1.useParams)();
    const { selectedYear } = (0, YearContext_1.useYear)();
    const [companies, _setCUrl, _setCBody, refreshCompanyData] = (0, useFetch_1.default)("admin/companies.json");
    const companyIdNumber = Number(companyId);
    const company = companies.status === apiUtils_1.LoaderStatus.Success
        ? companies.data.find((c) => c.id === companyIdNumber)
        : undefined;
    const [pools, _1, setPoolsBody] = (0, useFetch_1.default)("admin/pools.json", undefined, true);
    const [fleets, _2, setFleetsBody] = (0, useFetch_1.default)("admin/fleets.json", undefined, true);
    const [ships, _3, setShipsBody] = (0, useFetch_1.default)("admin/ships.json", undefined, true);
    (0, react_1.useEffect)(() => {
        setPoolsBody(JSON.stringify({ company_id: companyIdNumber, year: selectedYear }));
        setFleetsBody(JSON.stringify({ company_id: companyIdNumber, year: selectedYear }));
        setShipsBody(JSON.stringify({ company_id: companyIdNumber, year: selectedYear }));
    }, [selectedYear]);
    const [monthly_reports, _setMonthlyReportsUrl, setMonthlyReportsBody, setMonthlyReportsVariations,] = (0, useFetchAll_1.default)("admin/monthly_data.json", {
        year: selectedYear,
        company_id: companyIdNumber,
    });
    const [bookings, _setBookingsUrl, setBookingsBody, setBookingsVariations, refreshBookings,] = (0, useFetchAll_1.default)("admin/pool_bookings.json", {
        year: selectedYear,
    });
    (0, react_1.useEffect)(() => {
        setMonthlyReportsBody({
            year: selectedYear,
            company_id: companyIdNumber,
        });
        setBookingsBody({
            year: selectedYear,
        });
    }, [companyIdNumber, selectedYear]);
    (0, react_1.useEffect)(() => {
        if (pools.status === apiUtils_1.LoaderStatus.Success) {
            const poolIds = pools.data.map((p) => p.id);
            setMonthlyReportsVariations({
                key: "pool_id",
                variations: poolIds,
            });
            setBookingsVariations({
                key: "pool_id",
                variations: poolIds,
            });
        }
    }, [pools.status]);
    const [metadata] = (0, useMetadata_1.useMetadata)();
    // log([
    //   {
    //     label: "Company",
    //     content: company,
    //   },
    //   {
    //     label: "Pools",
    //     content: pools.status === LoaderStatus.Success ? pools.data : "loading",
    //   },
    //   {
    //     label: "Monthly reports",
    //     content: monthly_reports,
    //   },
    // {
    //   label: "Fleets",
    //   content: fleets.status === LoaderStatus.Success ? fleets.data : "loading",
    // },
    // {
    //   label: "Ships",
    //   content: ships.status === LoaderStatus.Success ? ships.data : "loading",
    // },
    // ]);
    if (companies.status === apiUtils_1.LoaderStatus.Error ||
        fleets.status === apiUtils_1.LoaderStatus.Error ||
        pools.status === apiUtils_1.LoaderStatus.Error ||
        ships.status === apiUtils_1.LoaderStatus.Error) {
        return ((0, jsx_runtime_1.jsx)(common_styled_components_1.PageContent, { align: "left", children: "Could not load data, please try again." }));
    }
    if (companies.status !== apiUtils_1.LoaderStatus.Success ||
        company === undefined ||
        fleets.status !== apiUtils_1.LoaderStatus.Success ||
        !fleets.data ||
        pools.status !== apiUtils_1.LoaderStatus.Success ||
        !pools.data ||
        ships.status !== apiUtils_1.LoaderStatus.Success ||
        !ships.data ||
        !metadata) {
        return (0, jsx_runtime_1.jsx)(common_styled_components_1.PageContent, { align: "left", children: "Loading\u2026" });
    }
    const nonCompliantShips = ships.data.filter((s) => s.intensity.adjusted_emission_balance_ton < 0).length;
    const nonCompliantPools = pools.data.filter((p) => p.intensity.adjusted_emission_balance_ton < 0).length;
    const bookingData = bookings.status === apiUtils_1.LoaderStatus.Success
        ? bookings.data.flatMap((poolBookings) => (poolBookings ?? []).filter((booking) => booking.company.id === companyIdNumber))
        : [];
    const bookingsByPool = pools.data.map((pool) => ({
        pool,
        bookings: bookingData.filter((booking) => booking.pool.id === pool.id),
    }));
    // const [
    //   expectedInventory,
    //   _setExpectedInventoryUrl,
    //   _setExpectedInventoryBody,
    //   refreshExpectedInventory,
    // ] = useFetch<PoolComplianceInventoryExpected>(
    //   "admin/pool_compliance_inventory_expected.json",
    //   undefined,
    //   true,
    // );
    // const [
    //   validatedInventory,
    //   _setValidatedInventoryUrl,
    //   _setValidatedInventoryBody,
    //   refreshValidatedInventory,
    // ] = useFetch<PoolComplianceInventoryValidated>(
    //   "admin/pool_compliance_inventory_validated.json",
    //   undefined,
    //   true,
    // );
    //   useEffect(() => {
    //     const body = JSON.stringify({
    //       company_id: Number(company.),
    //       year: selectedYear,
    //     });
    //     _setExpectedInventoryBody(body);
    //     _setValidatedInventoryBody(body);
    //   }, [poolId, selectedYear]);
    // const expectedInventoryData =
    //   expectedInventory.status === LoaderStatus.Success
    //     ? expectedInventory.data
    //     : undefined;
    // const validatedInventoryData =
    //   validatedInventory.status === LoaderStatus.Success
    //     ? validatedInventory.data
    //     : undefined;
    // const currentStatusItems: KPIItem[] = [
    //   {
    //     color:
    //       (analysis &&
    //         complianceOptions[
    //           getCompliance(
    //             analysis?.intensities.total.adjusted_emission_balance_ton,
    //           )
    //         ].color) ??
    //       theme.colors.blackText,
    //     title: "Carbon intensity",
    //     subtitle: "Report-based",
    //     unit: "gCO₂e/MJ",
    //     value: analysis?.intensities.total.adjusted_intensity_gCO2e_per_MJ,
    //     digits: 2,
    //   },
    //   {
    //     color:
    //       (analysis &&
    //         complianceOptions[
    //           getCompliance(analysis?.intensities.total.emission_balance_ton)
    //         ].color) ??
    //       theme.colors.blackText,
    //     title: "Emission balance",
    //     subtitle: "Report-based",
    //     unit: "tCO₂e",
    //     value: analysis?.intensities.total.adjusted_emission_balance_ton,
    //     digits: 0,
    //     showPositiveSign: true,
    //   },
    // ];
    // const inventoryItems: KPIItem[] = [
    //   {
    //     color: theme.colors.blackText,
    //     value: expectedInventoryData?.expected_bookable_inventory_tco2e,
    //     title: "Expected inventory",
    //     subtitle: "EOY booking estimate",
    //     unit: "tCO₂e",
    //     digits: 2,
    //     showPositiveSign: true,
    //   },
    //   {
    //     color: theme.colors.blackText,
    //     value: expectedInventoryData?.total_booked_tco2e,
    //     title: "Booked",
    //     subtitle: "EOY booking estimate",
    //     unit: "tCO₂e",
    //     digits: 2,
    //   },
    //   {
    //     color: getInventoryColor(
    //       expectedInventoryData?.available_after_bookings_tco2e,
    //     ),
    //     value: expectedInventoryData?.available_after_bookings_tco2e,
    //     title: "Available after bookings",
    //     subtitle: "EOY booking estimate",
    //     unit: "tCO₂e",
    //     digits: 2,
    //     showPositiveSign: true,
    //   },
    // ];
    // const validatedInventoryItems: KPIItem[] = [
    //   {
    //     color: theme.colors.blackText,
    //     value: validatedInventoryData?.validated_balance_tco2e,
    //     title: "Validated balance",
    //     subtitle: "Validated inventory",
    //     unit: "tCO₂e",
    //     digits: 1,
    //     showPositiveSign: true,
    //   },
    //   {
    //     color: theme.colors.blackText,
    //     value: validatedInventoryData?.total_transaction_quantity_tco2e,
    //     title: "Transactions",
    //     subtitle: "Validated inventory",
    //     unit: "tCO₂e",
    //     digits: 1,
    //   },
    //   {
    //     color: theme.colors.blackText,
    //     value: validatedInventoryData?.remaining_after_transactions_tco2e,
    //     title: "Remaining after transactions",
    //     subtitle: "Validated inventory",
    //     unit: "tCO₂e",
    //     digits: 1,
    //     showPositiveSign: true,
    //   },
    // ];
    return ((0, jsx_runtime_1.jsx)("div", { style: { width: "100%", padding: theme_1.theme.spacing(5) }, children: (0, jsx_runtime_1.jsxs)(common_styled_components_1.PageContent, { align: "left", children: [(0, jsx_runtime_1.jsxs)(common_styled_components_1.ContentGrid, { children: [(0, jsx_runtime_1.jsxs)(common_styled_components_1.GridCard, { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.SectionTitle, { children: company.name }), (0, jsx_runtime_1.jsxs)(common_styled_components_1.PTight, { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.Bold, { children: "Ships: " }), ships.data.length] }), (0, jsx_runtime_1.jsxs)(common_styled_components_1.PTight, { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.Bold, { children: "Pools: " }), pools.data.length] }), (0, jsx_runtime_1.jsxs)(common_styled_components_1.PTight, { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.Bold, { children: "Fleets: " }), fleets.data.length] })] }), (0, jsx_runtime_1.jsx)(common_styled_components_1.GridCard, { children: (0, jsx_runtime_1.jsx)(NumberKPI_1.default, { title: "non-compliant ships", value: nonCompliantShips, color: nonCompliantShips > 0
                                    ? theme_1.theme.colors.blackText
                                    : theme_1.theme.colors.green }) }), (0, jsx_runtime_1.jsx)(common_styled_components_1.GridCard, { children: (0, jsx_runtime_1.jsx)(NumberKPI_1.default, { title: "non-compliant pools", value: nonCompliantPools, color: nonCompliantPools > 0
                                    ? theme_1.theme.colors.blackText
                                    : theme_1.theme.colors.green }) })] }), (0, jsx_runtime_1.jsx)(common_styled_components_1.ContentGrid, { "$cols": 1, children: (0, jsx_runtime_1.jsxs)(common_styled_components_1.GridCard, { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.SectionTitle, { children: "Bookings" }), bookingsByPool?.length ? (bookingsByPool.map(({ pool, bookings }) => ((0, jsx_runtime_1.jsxs)("div", { style: { marginBottom: theme_1.theme.spacing(4) }, children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.PTight, { children: (0, jsx_runtime_1.jsx)(common_styled_components_1.Bold, { children: pool.name }) }), (0, jsx_runtime_1.jsx)(BookingTable_1.BookingTable, { bookings: bookings, pool: pool, companyId: company.id, isInAdminTools: true, refresh: refreshBookings })] }, pool.id)))) : ((0, jsx_runtime_1.jsx)(BookingTable_1.BookingTable, { bookings: [], companyId: company.id, isInAdminTools: true, refresh: refreshBookings }))] }) }), (0, jsx_runtime_1.jsx)(common_styled_components_1.ContentGrid, { "$cols": 1, children: (0, jsx_runtime_1.jsx)(common_styled_components_1.GridCard, { children: (0, jsx_runtime_1.jsx)(CompanyYearlyPlanTable_1.CompanyYearlyDataTable, { company: company, metadata: metadata, isInAdminTools: true, refresh: refreshCompanyData }) }) }), (0, jsx_runtime_1.jsx)(common_styled_components_1.ContentGrid, { "$cols": 1, children: (0, jsx_runtime_1.jsx)(common_styled_components_1.GridCard, { children: (0, jsx_runtime_1.jsx)(PoolTable_1.PoolTable, { pools: pools.data, isInAdminTools: true }) }) }), (0, jsx_runtime_1.jsx)(common_styled_components_1.ContentGrid, { "$cols": 1, children: (0, jsx_runtime_1.jsx)(common_styled_components_1.GridCard, { children: (0, jsx_runtime_1.jsx)(FleetTable_1.FleetTable, { fleets: fleets.data, isInAdminTools: true }) }) }), (0, jsx_runtime_1.jsx)(common_styled_components_1.ContentGrid, { "$cols": 1, children: (0, jsx_runtime_1.jsx)(common_styled_components_1.GridCard, { children: (0, jsx_runtime_1.jsx)(ShipTable_1.ShipTable, { ships: ships.data, isInAdminTools: true, metadata: metadata, year: selectedYear, showPool: true }) }) })] }) }));
};
